exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bottom p\n{\n    color: black;\n}\n\n.bottom {\n    text-align: center;\n    margin-right: 10em;\n    margin-left: 10em;\n    margin-top: 5em;\n  }\n\n.logo {\n    size: 30%;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/skye/Projects/Epicodus Projects/JavaScript/mock-mint/src/app/highlight/highlight.component.css
// module id = ../../../../../src/app/highlight/highlight.component.css
// module chunks = main